import api from './index';

export const apiAuthPartner = async (partner, token) => {
  try {
    const query = token ? `?token=${token}` : '';
    const { data } = await api.get(`/partner/${partner}/landing${query}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const sendVerificationEmail = async (email) => {
  try {
    const { data } = await api.patch('/send-verification-email', { email });
    return data;
  } catch (error) {
    throw error;
  }
};

export const unifyUsers = async (target_user, user_to_be_removed) => {
  try {
    const { data } = await api.post('/users/unify-users', { target_user, user_to_be_removed });
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (fields, userId) => {
  const { data } = await api.put(`/user/${userId}`, { user: fields });
  if (!data.success) {
    throw new Error(data.error);
  }
  return data;
};

export const getUserById = async (userID) => {
  try {
    const { data } = await api.get(`/user/${userID}`);
    return data;
  } catch (error) {
    throw error;
  }
};
